<script>
import ClienShowPage from '../../associate/Clients/Show';

export default {
  name: 'AdminClientShow',
  extends: ClienShowPage,
};
</script>
